<!-- <tt-page> -->
<!-- <tt-page-heading>Video: Lorem ipsum dolor sit amet</tt-page-heading> -->
<!-- <script src="https://www.youtube.com/iframe_api"></script> -->
<div style="display: flex; flex: 1; max-width: 180rem">
    <tt-card class="flex-1" ttTranslateHeading="false">
        <!-- <iframe
                frameborder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media"
                src="https://player.vimeo.com/video/1083503632?h=e2134968e9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                title="New Recording - 12.5.2025, 14:28:11"
                style="width: 100%; max-width: 180rem; aspect-ratio: 16 / 9"
            ></iframe> -->

        <!-- [src]="https://www.youtube.com/embed/0RDi6YDLDKU" -->
        <!-- <iframe
            [src]="_src"
            title="Ordrelinjer med overskrift"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            allowfullscreen
            style="width: 100%; aspect-ratio: 16 / 9"
            ></iframe> -->
        <div class="youtube-container">
            <youtube-player *ngIf="isBrowser" [playerVars]="playerVars" [videoId]="videoId" (stateChange)="onStateChanged($event)" />
        </div>
    </tt-card>
    <!-- <tt-video-tutorials style="width: 40rem; height: 100%" ttCompact></tt-video-tutorials> -->
</div>
<!-- </tt-page> -->
